import { render, staticRenderFns } from "./BankTransferList.vue?vue&type=template&id=c494a4fc&scoped=true"
import script from "./BankTransferList.vue?vue&type=script&setup=true&lang=ts"
export * from "./BankTransferList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/bankTransfers/css/bank-transfer-overview-style.css?vue&type=style&index=0&id=c494a4fc&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c494a4fc",
  null
  
)

/* custom blocks */
import block0 from "@/components/bankTransfers/locales/i18n-bank-transfer-overview?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2FbankTransfers%2Fchildren%2FBankTransferList.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports